import env from './utils/getEnv'
import appVersion from './appVersion.json'

function getApiUrl(): string {
  switch (env) {
    case 'local':
      return 'http://localhost:8050/api/v1/';
    case 'dev':
      return 'https://57x0heq9a4.execute-api.us-east-1.amazonaws.com/dev/api/v1/';
    default:
      return 'https://yzpozeud08.execute-api.us-east-1.amazonaws.com/prod/api/v1/';
  }
}

export function getAuthParams(): string {
  switch (env) {
    case 'local':
      return 'http://localhost:3000/auth/google?frontend=www&sport=baseball&env=local&prompt=select_account';
    case 'dev':
      return 'https://i9gdv5fky2.execute-api.us-east-1.amazonaws.com/auth/google?frontend=www&sport=baseball&prompt=select_account&env=dev';
    default:
      return 'https://i9gdv5fky2.execute-api.us-east-1.amazonaws.com/auth/google?frontend=www&sport=baseball&prompt=select_account&env=prod';
  }
}

export const API_URL = getApiUrl();
export const AUTH_URL = env === 'local' ? 'http://localhost:3000' : 'https://i9gdv5fky2.execute-api.us-east-1.amazonaws.com';
//export const CHAT_URL = env === 'local' ? 'http://localhost:3001' : 'https://dominus-chat.curveten.com';
export const CHAT_URL = 'https://beta.dominusbaseball.com';//'http://localhost:3000';//;

export const POSITIONS = [
  { label: 'Pitcher', value: 'P' },
  { label: 'Starting Pitcher', value: 'SP' },
  { label: 'Relief Pitcher', value: 'RP' },
  { label: 'Closer', value: 'CL' },
  { label: 'Catcher', value: 'CA' },
  { label: '1B', value: '1B' },
  { label: '2B', value: '2B' },
  { label: '3B', value: '3B' },
  { label: 'SS', value: 'SS' },
  { label: 'Infield', value: 'IF' },
  { label: 'LF', value: 'LF' },
  { label: 'CF', value: 'CF' },
  { label: 'RF', value: 'RF' },
  { label: 'LRF', value: 'LRF' },
  { label: 'OF', value: 'OF' },
  { label: 'DH', value: 'DH' },
];

export const LEVELS = [
  { label: 'AA', value: 'AA' },
  { label: 'R', value: 'R' },
  { label: 'AAA', value: 'AAA' },
  { label: 'MLB', value: 'MLB' },
  { label: 'DSL', value: 'DSL' },
  { label: 'A+', value: 'A+' },
  { label: 'RA', value: 'RA' },
  { label: 'A-', value: 'A-' },
];

export const STAT_TYPES = [
  { value: 'salaries', label: 'Salaries' },
  { value: 'pitching', label: 'Pitching Stats' },
  { value: 'batting', label: 'Batting Stats' },
];

export const YEARS = {
  items: [
    { label: "2018", value: 2018 },
    { label: "2019", value: 2019 },
    { label: "2020", value: 2020 },
    { label: "2021", value: 2021 },
    { label: "2022", value: 2022 },
  ]
};

export const MLB_TEAM_ABBREVIATIONS = [
  { name: 'Angels', abbr: 'LA (AL)' },
  { name: 'Astros', abbr: 'HOU' },
  { name: 'Athletics', abbr: 'LAS' },
  { name: 'Blue Jays', abbr: 'TOR' },
  { name: 'Braves', abbr: 'ATL' },
  { name: 'Brewers', abbr: 'MIL' },
  { name: 'Cardinals', abbr: 'STL' },
  { name: 'Cubs', abbr: 'CHI (NL)' },
  { name: 'Diamondbacks', abbr: 'ARI' },
  { name: 'Dodgers', abbr: 'LA (NL)' },
  { name: 'Giants', abbr: 'SF' },
  { name: 'Guardians', abbr: 'CLE' },
  { name: 'Mariners', abbr: 'SEA' },
  { name: 'Marlins', abbr: 'MIA' },
  { name: 'Mets', abbr: 'NY (NL)' },
  { name: 'Nationals', abbr: 'WAS' },
  { name: 'Orioles', abbr: 'BAL' },
  { name: 'Padres', abbr: 'SD' },
  { name: 'Phillies', abbr: 'PHI' },
  { name: 'Pirates', abbr: 'PIT' },
  { name: 'Rangers', abbr: 'TEX' },
  { name: 'Rays', abbr: 'TB' },
  { name: 'Red Sox', abbr: 'BOS' },
  { name: 'Reds', abbr: 'CIN' },
  { name: 'Rockies', abbr: 'COL' },
  { name: 'Royals', abbr: 'KC' },
  { name: 'Tigers', abbr: 'DET' },
  { name: 'Twins', abbr: 'MIN' },
  { name: 'White Sox', abbr: 'CHI (AL)' },
  { name: 'Yankees', abbr: 'NY (AL)' },
];

// Deal status constants
export const DEAL_STATUSES = {
  PROPOSED: 'proposed',
  COUNTERED: 'countered',
  ACCEPTED: 'accepted',
  APPROVED: 'approved',
  DECLINED: 'declined',
  REJECTED: 'rejected',
  WITHDRAWN: 'withdrawn',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
  UNDER_REVIEW: 'under_review', // proposed deals that are under review
  SETTLEMENT_TRADE: 'settlement_trade', // deals that are in trade settlement
  SETTLEMENT_WAIVER_CLAIM: 'settlement_waiver_claim', // deals that are in claim waiver settlement
  SETTLEMENT_FREE_AGENT: 'settlement_free_agent', // deals that are in free agent bid settlement
  LEAGUE_REVIEW: 'league_review',
  HAS_SALARY_ISSUE: 'has_salary_issue',
  SUCCESS: 'success',
  CONTRACT_EXTENSION_PERIOD: 'contract_extension_period',
  WAIVED: 'waived',
  CLAIMED: 'claimed',
  FREE_AGENT_OFFER: 'free_agent_offer',
} as const;

export const DEAL_STATUS_CONFIG = {
  [DEAL_STATUSES.PROPOSED]: { color: 'green', text: 'Proposed' },
  [DEAL_STATUSES.COUNTERED]: { color: 'teal', text: 'Countered' },
  [DEAL_STATUSES.ACCEPTED]: { color: 'green', text: 'Agreed' },
  [DEAL_STATUSES.APPROVED]: { color: 'purple', text: 'Approved' },
  [DEAL_STATUSES.DECLINED]: { color: 'pink', text: 'Declined' },
  [DEAL_STATUSES.REJECTED]: { color: 'purple', text: 'Canceled' },
  [DEAL_STATUSES.WITHDRAWN]: { color: 'orange', text: 'Withdrawn' },
  [DEAL_STATUSES.EXPIRED]: { color: 'gray', text: 'Expired' },
  [DEAL_STATUSES.CANCELED]: { color: 'gray', text: 'Canceled' },
  [DEAL_STATUSES.UNDER_REVIEW]: { color: 'yellow', text: 'Trade under review' },
  [DEAL_STATUSES.SETTLEMENT_TRADE]: { color: 'green', text: 'Settling trade' },
  [DEAL_STATUSES.SETTLEMENT_WAIVER_CLAIM]: { color: 'orange', text: 'Settling waiver claim' },
  [DEAL_STATUSES.SETTLEMENT_FREE_AGENT]: { color: 'orange', text: 'Settling free agent signing' },
  [DEAL_STATUSES.LEAGUE_REVIEW]: { color: 'yellow', text: 'League Review' },
  [DEAL_STATUSES.HAS_SALARY_ISSUE]: { color: 'red.700', text: 'Has Salary Issue' },
  [DEAL_STATUSES.SUCCESS]: { color: 'green.500', text: 'Success' },
  [DEAL_STATUSES.CONTRACT_EXTENSION_PERIOD]: { color: 'orange', text: 'Contract Extension Period' },
  [DEAL_STATUSES.WAIVED]: { color: 'orange', text: 'Waived' },
  [DEAL_STATUSES.CLAIMED]: { color: 'orange', text: 'Claimed' },
  [DEAL_STATUSES.FREE_AGENT_OFFER]: { color: 'orange', text: 'Free Agent Offer' },
} as const;

// this is temporary for when beta testing and only allowing certain users to own teams
export const USE_CODE_FOR_OWNERSHIP = true;

/// READ THIS!!!! **************** READ THIS ****************** READ THIS
// cachebusting requires version number to only numbers with periods:
// 1.00.000  
// exactly that many digits... just add one from the LSD
// AND, set the version in appVersion.json
export const VERSION = appVersion.version; // edd - force version to standard for cache busting 5/23/23

export const ROSTER_SECTIONS_CONFIG = [
  {
    order: 0,
    level: 'MLB',
    status: ['active'],
    label: 'Active Roster',
    actionMenu: 'activeRoster',
    on40Man: true, // Active roster is on 40-man
  },
  {
    order: 1,
    level: 'MLB',
    status: ['10-day dl', '10 day dl', '10-day il', '10 day il', 'dl10', 'dl', '10 day disabled list', '10-day disabled list'],
    label: '10 Day Injured List',
    actionMenu: 'dl10',
    on40Man: true, // 10 day DL is on 40-man
  },
  {
    order: 2,
    level: 'MLB',
    status: ['60-day dl', '60 day dl', '60-day il', '60 day il', 'dl60', '60 day disabled list', '60-day disabled list'],
    label: '60 Day Injured List',
    actionMenu: 'dl60',
    on40Man: false, // 60 day IL is NOT on 40-man
  },
  {
    order: 3,
    level: 'MLB',
    status: ['7-day dl', '7 day dl', '7-day il', '7 day il', 'dl7', 'concussion', 'cl'],
    label: '7 Day Concussion DL',
    actionMenu: 'dl7',
    on40Man: true, // 7 day DL is on 40-man
  },
  {
    order: 4,
    level: 'MLB',
    status: ['rehab'],
    label: 'Rehab',
    actionMenu: 'rehab',
    on40Man: true, // Rehab is on 40-man (assumed)
  },
  {
    order: 5,
    level: 'MLB',
    status: ['bereavement', 'bl'],
    label: 'Bereavement List',
    actionMenu: 'bereavement',
    on40Man: true, // Bereavement is on 40-man
  },
  {
    order: 6,
    level: 'MLB',
    status: ['paternity', 'pl'],
    label: 'Paternity Leave',
    actionMenu: 'paternity',
    on40Man: true, // Paternity is on 40-man
  },
  {
    order: 7,
    level: 'MLB',
    status: ['restricted'],
    label: 'Restricted List',
    actionMenu: 'restricted',
    on40Man: false, // Restricted is NOT on 40-man
  },
  {
    order: 8,
    level: 'MLB',
    status: ['suspended'],
    label: 'Suspended List',
    actionMenu: 'suspended',
    on40Man: false, // Suspended is NOT on 40-man
  },
  {
    order: 9,
    level: 'MLB',
    status: ['dfa', 'designated for assignment'],
    label: 'Designated for Assignment',
    actionMenu: 'dfa',
    on40Man: false, // DFA is NOT on 40-man
  },
  {
    order: 10,
    level: 'MLB',
    status: ['waivers'],
    label: 'Waivers',
    actionMenu: 'waivers',
    on40Man: false, // Waivers is NOT on 40-man
  },
  // Anyone lower on the list than Waivers is not on the 40 man as they're in the minor leagues
  {
    order: 11,
    level: 'AAA',
    status: [],
    label: 'AAA',
    actionMenu: 'minorLeague',
    on40Man: false,
  },
  {
    order: 12,
    level: 'AA',
    status: [],
    label: 'AA',
    actionMenu: 'minorLeague',
    on40Man: false,
  },
  {
    order: 13,
    level: 'High A',
    status: [],
    label: 'High A',
    actionMenu: 'minorLeague',
    on40Man: false,
    levelAliases: ['High-A'],
  },
  {
    order: 14,
    level: 'Low A',
    status: [],
    label: 'Low A',
    actionMenu: 'minorLeague',
    on40Man: false,
    levelAliases: ['Low-A', 'A'],
  },
  {
    order: 15,
    level: 'Advanced Rookie',
    status: ['advanced rookie'],
    label: 'Advanced Rookie Ball',
    actionMenu: 'minorLeague',
    on40Man: false,
  },
  {
    order: 16,
    level: 'Rookie',
    status: ['rookie'],
    label: 'Rookie Ball',
    actionMenu: 'minorLeague',
    on40Man: false,
    levelAliases: ['Complex'],
  },
  {
    order: 17,
    level: 'EST',
    status: ['est'],
    label: 'EST',
    actionMenu: 'minorLeague',
    on40Man: false,
  },
  {
    order: 18,
    level: 'DSL',
    status: ['dsl'],
    label: 'DSL',
    actionMenu: 'minorLeague',
    on40Man: false,
  },
  {
    order: 19,
    level: 'MiLB',
    status: ['minor league dl', 'mldl'],
    label: 'Minor League Injured List',
    actionMenu: 'milbDL',
    on40Man: false,
  },
];

export const TEAM_ROSTER_SIZE = 40;
export const CURRENT_YEAR = new Date().getFullYear();
export function getActiveRosterSize() {
  const now = new Date();
  const month = now.getMonth() + 1;
  // Sep 1 (9/1) to Oct 31 (10/31) is 28-man roster
  if (month === 9 || month === 10) return 28;
  return 26;
}
export const ACTIVE_ROSTER_SIZE = getActiveRosterSize();

// Roster move confirmation messages/buttons used across components
export const ROSTER_MOVES_CONFIRMATION_MESSAGES: { [key: string]: string[] } = {
  "Release": [
    "Confirming you would like to release <firstName> <lastName>. Upon release, he will become a free agent.",
    "You will still be responsible for his total salary until another team signs him.",
  ],
  "Designate for Assignment and Waivers": [
    "Confirming you want to designate <firstName> <lastName> for assignment. If you do, you will have 7 days to trade him.",
    "After 7 days, he will be placed on waivers for 72 hours to allow other teams to claim him.",
    "If no one claims him, he will be made a free agent and you will still be responsible for his salary.",
  ],
  "Designate for Assignment and Waivers - To AAA": [
    "Confirming you want to designate <firstName> <lastName> for assignment. If you do, you will have 7 days to trade him.",
    "After 7 days, he will be placed on waivers for 72 hours to allow other teams to claim him.",
    "If no one claims him, he will be moved to AAA.",
  ],
  "Move to 60 Day IL": [
    "Confirming you would like to place <firstName> <lastName> on 60 Day IL. You will still be responsible for his salary.",
  ],
  "Outright Waivers": [
    "Confirming you would like to place <firstName> <lastName> on Outright Waivers.",
  ],
  "Outright to AAA": [
    "Confirming you would like to place <firstName> <lastName> on Outright Waivers (AAA).",
  ],
  "Extend Offer": [
    "Confirming you would like to extend a qualified offer for <firstName> <lastName>. The contract offered will be <salary> for one year.",
    "If the player declines the offer, he will become a free agent.",
    "If he becomes a free agent and signs a new contract, your team will be awarded draft compensation based on that contract."
  ],
  "Buy Franchise Tag": [
    "Confirming you would like to buy a franchise tag for <firstName> <lastName>. The contract offered will be <salary> for one year.",
    "If the player declines the offer, he will become a free agent.",
    "If he becomes a free agent and signs a new contract, your team will be awarded draft compensation based on that contract."
  ],
  "Option to AAA": [
    " <firstName> <lastName> will moved to your AAA roster.",
    "He will be removed from your Active (26-man) roster, but will remain on your 40-man roster.",
    "He cannot be recalled to the Majors for 10 days.",
  ],
  "Move to 10 Day IL": [
    "<firstName> <lastName> will be placed on the 10 Day IL roster.",
    "You will still be responsible for his salary.",
  ],
  "Move to AAA": [
    " <firstName> <lastName> will be placed on the AAA roster.",
  ],
  "Move to AA": [
    " <firstName> <lastName> will be placed on the AA roster.",
  ],
  "Move to High A": [
    " <firstName> <lastName> will be placed on the High A roster.",
  ],
  "Move to Low A": [
    " <firstName> <lastName> will be placed on the Low A roster.",
  ],
  // "Move to Advanced Rookie Ball": [
  //   " <firstName> <lastName> will be placed on the Advanced Rookie Ball roster.",
  // ],
  "Move to Rookie Ball": [
    " <firstName> <lastName> will be placed on the Rookie Ball roster.",
  ],
  // "Move to EST": [
  //   " <firstName> <lastName> will be placed on the EST roster.",
  // ],
  "Move to DSL": [
    " <firstName> <lastName> will be placed on the DSL roster.",
  ],
  "Move to Minor League IL": [
    " <firstName> <lastName> will be placed on the Minor League IL roster.",
  ],
  "Move to Rehab": [
    " <firstName> <lastName> will be placed on the Rehab roster.",
  ],
  "Move to Bereavement List": [
    " <firstName> <lastName> will be placed on the Bereavement List roster.",
  ],
  "Promote to MLB": [
    " <firstName> <lastName> will be placed on the MLB roster. He will be added to the 40-man roster and the 26-man active roster.",
    "If he doesn't have a current contract, he will be added with a contract for one year at the minimum salary",
  ],
  "Activate from Injured List": [
    " <firstName> <lastName> will be placed on the Active Roster.",
    "If he doesn't have a current contract, he will be added with a contract for one year at the minimum salary.",
  ],
};

export const ROSTER_MOVES_CONFIRMATION_BUTTONS: { [key: string]: { button1: string; button2: string } } = {
  "Release": { button1: "Release Him", button2: "" },
  "Designate for Assignment and Waivers": { button1: "Designate for Assignment", button2: "Cancel" },
  "Move to 60 Day IL": { button1: "Put him on 60 Day IL", button2: "Cancel" },
  "Outright to AAA": { button1: "Outright him to AAA", button2: "Cancel" },
  "Extend Offer": { button1: "Extend Offer", button2: "Cancel " },
  "Buy Franchise Tag": { button1: "Buy Franchise Tag", button2: " " },
  "Option to AAA": { button1: "Option to AAA", button2: "Cancel " },
  "Move to 10 Day IL": { button1: "Move to 10 Day IL", button2: "Cancel" },
  "Move to AAA": { button1: "Move to AAA", button2: "Cancel " },
  "Move to AA": { button1: "Move to AA", button2: "Cancel " },
  "Move to High A": { button1: "Move to High A", button2: "Cancel " },
  "Move to Low A": { button1: "Move to Low A", button2: "Cancel " },
  // "Move to Advanced Rookie Ball": { button1: "Move to Advanced Rookie Ball", button2: "Cancel " },
  "Move to Rookie Ball": { button1: "Move to Rookie Ball", button2: "Cancel " },
  // "Move to EST": { button1: "Move to EST", button2: "Cancel " },
  "Move to DSL": { button1: "Move to DSL", button2: "Cancel " },
  "Move to Minor League IL": { button1: "Move to Minor League IL", button2: "Cancel " },
  "Move to Rehab": { button1: "Move to Rehab", button2: "Cancel " },
  "Move to Bereavement List": { button1: "Move to Bereavement List", button2: "Cancel " },
  "Promote to MLB": { button1: "Promote to MLB", button2: "Cancel" },
};

// export const EMBARGO_TEST_DATE = '2026-04-03';

// test stripekey
// export const STRIPE_KEY = 'pk_test_51RVzNs4EjWVTFp4qcbZ2XsdekV5bKsItQiiynpOfkUUcWVpT9CoZhzrrCEFqQJws7Zyn6enHfC7q6UTOynzJYuAz00aIcZ52pM';

// live stripe key
export const STRIPE_KEY = 'pk_live_51RVzNkKQQ7FoC4vj9D4aLluPklZ51WsaNtMaxaxYpE2oS0G4WCNgtfTGlEYLAyQressXB8L19oZXL1kMw2eJl2gG00wFD2hXas';

/** Broadcast play-by-play replay timing (`BroadcastGame`). */
export const BROADCAST_PBP_POPUP_MS = 2000;
/** Inning intro / between-inning popups stay on screen this factor × `BROADCAST_PBP_POPUP_MS`. */
export const BROADCAST_PBP_INNING_POPUP_MULTIPLIER = 1.5;
export const BROADCAST_PBP_BETWEEN_MS = 250;

/** Bold ornament labels in cleaned broadcast PBP (`BroadcastGame` / `parseBroadcastPbpDisplay`). */
export const BROADCAST_PBP_LABEL_COLOR_GAME_OVER = 'teal.200';
/** “First” accent — PINCH HITTER */
export const BROADCAST_PBP_LABEL_COLOR_PINCH_HITTER = 'cyan.300';
/** Muted / variant of first accent — DEFENSIVE CHANGE */
export const BROADCAST_PBP_LABEL_COLOR_DEFENSIVE_CHANGE = 'cyan.600';
/** Second accent — RELIEF PITCHER */
export const BROADCAST_PBP_LABEL_COLOR_RELIEF_PITCHER = 'orange.300';
/** Out count accent — 1 OUT / 2 OUTS / 3 OUTS tags in broadcast PBP */
export const BROADCAST_PBP_LABEL_COLOR_OUT = 'red.400';
/** Error accent — ERROR pill in broadcast PBP list view */
export const BROADCAST_PBP_LABEL_COLOR_ERROR = '#cccccc';
/** Score line accent — “Score is X - Y” in broadcast PBP */
export const BROADCAST_PBP_LABEL_COLOR_SCORE = 'green.400';
